import { useState, useEffect } from 'react';

const types = ['All','Domestic', 'International'];

const FilterTabs = ({ selectedType, onSelectType }) => {
  const [isVerySmall, setIsVerySmall] = useState(window.innerWidth < 300);

  useEffect(() => {
    const handleResize = () => setIsVerySmall(window.innerWidth < 300);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className={`flex space-x-1 mb-4 ${
        isVerySmall ? 'overflow-x-auto whitespace-nowrap' : ''
      }`}
    >
      {types.map(type => (
        <button
          key={type}
          onClick={() => onSelectType(type)}
          className={`
            px-3 py-1.5 text-sm font-medium rounded-md flex-shrink-0
            transition-colors duration-200
            ${selectedType === type 
              ? 'bg-orange-600 text-white' 
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }
          `}
          style={isVerySmall ? { minWidth: 100 } : {}}
        >
          {type}
        </button>
      ))}
    </div>
  );
};

export default FilterTabs;
